<template>
  <v-container fluid>
    <h3 class="mb-3">{{ turtaiTitle }}</h3>
    <v-data-table
      :loading="loading"
      :headers="filteredHeaders"
      :items="filteredItemsList"
      :search="search"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: 'Rodyti po:',
        itemsPerPageAllText: 'visi',
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
    >
      <template #[`item.turtas_registras`]="{ item }">
        <v-row dense no-gutters>
          <v-col cols="12" md="12">
            <div class="nowrap">{{ item.registras_nr }}</div>
          </v-col>
          <v-col cols="12" md="12">
            <div class="nowrap">{{ item.unikalus_nr }}</div>
          </v-col>
        </v-row>
      </template>
      <template #[`item.turtas_rusis`]="{ item }">
        <v-row dense no-gutters>
          <v-col cols="12" md="12">
            {{ item.tipas }}
          </v-col>
          <v-col cols="12" md="12">
            <span class="text-gray">{{ item.adresas }}</span>
          </v-col>
        </v-row>
      </template>
      <template slot="loading">
        Kraunasi...
      </template>
      <template slot="no-results">
        Duomenų nėra
      </template>
      <template slot="no-data">
        <div class="text-black">
          <el-savitarna-alert dense outlined type="warning2">
            {{ turtaiWarning }}
          </el-savitarna-alert>
        </div>
      </template>
      <template #[`footer.page-text`]="props">
        Rodoma {{ props.pageStart }}-{{ props.pageStop }} iš
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import PazymaMap from './PazymaMap'
export default {
  name: 'AsmensTurtai',
  props: {
    pazymaKodas: String,
  },
  data() {
    return {
      loading: true,
      search: null,
      searchData: {},
      turtai: [],
      yra_igaliotinis: null,

      itemsPerPageOptions: [10, 50, 100, -1],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Eil. Nr.'),
          align: 'center',
          value: 'eil_nr',
          width: 60,
        },
        {
          text: this.$t('Registro informacija'),
          align: 'start',
          value: 'turtas_registras',
          width: 150,
        },
        {
          text: this.$t('Turto rūšis, paskirtis'),
          align: 'start',
          value: 'turtas_rusis',
        },
        {
          text: this.$t('Bendras sklypo plotas, ha'),
          align: 'start',
          value: 'plotas',
          width: 100,
        },
        {
          text: this.$t('Priklausanti dalis'),
          align: 'start',
          value: 'dalis',
          width: 100,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    filteredItemsList() {
      let eil_nr = 1

      return this.turtai.map(turtas => {
        turtas.eil_nr = eil_nr++

        if (turtas.plotas && turtas.plotas[0] == '.') {
          turtas.plotas = '0' + turtas.plotas
        }

        return turtas
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    pazymaMap() {
      return PazymaMap.getPazymaTipas(this.pazymaKodas)
    },
    turtaiTitle() {
      return this.pazymaMap.turtaiTitle
    },
    turtaiWarning() {
      if (this.yra_igaliotinis) {
        return this.pazymaMap.turtaiIgaliojimasWarning
      }
      return this.pazymaMap.turtaiWarning
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true

      const data = {
        pazyma_tipas: this.pazymaKodas,
      }

      this.$axios
        .post(`ntrpaslaugos/pazyma/asmens-turtas`, data)
        .then(res => {
          this.turtai = res.data.asmens_turtas
          this.yra_igaliotinis = res.data.yra_igaliotinis
          this.yra_ntr_asmuo = res.data.yra_ntr_asmuo
          this.pagination.total = this.turtai.length
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          const payload = {
            turtas_sk: this.turtai.length,
            yra_igaliotinis: this.yra_igaliotinis,
            yra_ntr_asmuo: this.yra_ntr_asmuo,
          }
          this.$emit('loaded', payload)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.text-black {
  color: rgba(0, 0, 0, 0.87);
}
</style>
